import * as React from 'react';
import ReactTable, { Column } from 'react-table';
import { dateParser } from '@common/dateParser';
import { ContractErrorViewModel } from '@models/ContractError';
import { Link } from 'react-router-dom';
import { getRoute, RouteDefinitions } from '@common/route-definitions';
import { ModalProps } from '@common/components';
import { ContractErrorComplete } from 'src/contract-error/_components/contract-error-complete.component';

export interface ContractErrorSearchComponentProperties {
  readonly loading?: boolean;
  readonly pageCount: number;
  readonly contractErrorList: Array<ContractErrorViewModel>;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly totalResults?: number;
  readonly setIsLoading: (loading: boolean) => Promise<void>;
  readonly getContractErrorList: (
    pageNumber: number,
    pageSize: number,
    orderBy: string,
    orderDirection: string
  ) => Promise<any>;
  readonly completeContractError: (contractErrorId: number, completeDate: Date) => Promise<any>;
  readonly toggleModal: (modalProps?: ModalProps) => void;
}

export class ContractErrorSearchComponent extends React.Component<ContractErrorSearchComponentProperties> {
  private isInitialized: boolean = false;

  componentDidMount() {
    this.getContractErrorList();
  }

  getContractErrorList = async () => {
    await this.props.setIsLoading(true);
    await this.props.getContractErrorList(1, 10, 'toDoDate', 'desc');
    await this.props.setIsLoading(false);
  };

  complete = async (contractErrorId: number) => {
    this.props.toggleModal();
    await this.props.setIsLoading(true);
    await this.props.completeContractError(contractErrorId, dateParser.now().toDate());
    await this.props.setIsLoading(false);
    this.getContractErrorList();
  };

  handleComplete = (x: ContractErrorViewModel): void => {
    this.props.toggleModal({
      title: 'Online To-Do Completion',
      isSmall: true,
      component: ContractErrorComplete,
      saveLabel: 'Yes',
      closeLabel: 'No',
      saveCallback: () => this.complete(x.contractErrorId),
      closeCallback: this.props.toggleModal,
      childProps: {}
    });
  };

  render() {
    const columns: Column[] = [
      {
        accessor: (x: ContractErrorViewModel) =>
          x ? (
            <Link to={getRoute(RouteDefinitions.contract.OrderEdit, { id: +x.contractId! })} target="_blank">
              {x.contractNumber}
            </Link>
          ) : (
            'N/A'
          ),
        id: 'contractNumber',
        Header: 'Contract #',
        sortable: false,
        minWidth: 100
      },
      {
        accessor: 'orderNumber',
        Header: 'Order Code',
        sortable: false,
        minWidth: 150
      },
      {
        accessor: (x: ContractErrorViewModel) => (x ? <>{dateParser.parse(x.orderDate).format('l LT')}</> : 'N/A'),
        id: 'orderDate',
        Header: 'Order Date',
        sortable: true,
        defaultSortDesc: true,
        minWidth: 200
      },
      {
        accessor: 'toDoText',
        Header: 'To Do',
        sortable: false,
        minWidth: 300
      },
      {
        accessor: (x: ContractErrorViewModel) => (x ? <>{dateParser.parse(x.toDoDate).format('l LT')}</> : 'N/A'),
        id: 'toDoDate',
        Header: 'On the Grid',
        sortable: true,
        defaultSortDesc: true,
        minWidth: 250
      },
      {
        accessor: (x: ContractErrorViewModel) =>
          x ? (
            <a className={this.props.loading ? 'disabled' : 'active'} onClick={() => this.handleComplete(x)}>
              <i className="fas fa-fw fa-times pointer" />
            </a>
          ) : (
            'N/A'
          ),
        id: 'completeDate',
        Header: 'Action',
        sortable: false,
        minWidth: 50
      }
    ];
    return (
      <div className="pt-10 light-gray-bc">
        <h2>Online To-Do List</h2>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={this.props.contractErrorList || []}
          defaultPageSize={10}
          loading={this.props.loading}
          manual={true}
          onFetchData={this.handleFetchData}
          pages={this.props.pageCount}
        />
      </div>
    );
  }

  private handleFetchData = (state: {
    page: number;
    pageSize: number;
    sorted: Array<{ id: string; desc: boolean }>;
  }): void => {
    if (this.isInitialized) {
      const orderBy = state.sorted[0] ? state.sorted[0].id : 'toDoDate';
      const orderDirection = state.sorted[0] ? (state.sorted[0].desc ? 'desc' : 'asc') : 'asc';

      this.props.getContractErrorList(state.page + 1, state.pageSize, orderBy, orderDirection);
    }

    this.isInitialized = true;
  };

  // private handleSearch = (query: string): void => {
  //   this.isInitialized = true;
  //   this.props.getContractErrorList(
  //     query,
  //     1,
  //     this.props.pageSize,
  //     'toDoDate',
  //     'desc'
  //   );
  // };
}



// WEBPACK FOOTER //
// ./src/contract-error/_components/contract-error-search/contract-error-search.component.tsx